import { render, staticRenderFns } from "./deskbar-tabs.vue?vue&type=template&id=2b05132b&"
import script from "./deskbar-tabs.vue?vue&type=script&lang=js&"
export * from "./deskbar-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports